import CharFinder from "./CharFinder";
import InfoPage from "./InfoPage";

function App() {
  return (
      <div className="App">
        <h1 className='title'>anigme</h1>
        <InfoPage />
        <CharFinder/>
    </div>
  );
}

export default App;
